import React from 'react'

import Hero from './components/Hero'
import Intro from './components/Intro'
import Features from './components/Features'
import Callout from './components/Callout'
import { Props } from './data'
import ROUTE from './route'

import { API } from 'src/api'
import SEO from 'src/components/SEO'
import HallOfFame from 'src/components/sections/HallOfFame'
import Main from 'src/components/Main'
import Page from 'src/components/Page'
import { buildPath } from 'src/routing/utils'
import { PageConfig } from 'src/routing/types'

const seoImageUrl = 'https://superhi.s3.amazonaws.com/assets/images/seo/editor.png'

const HALL_OF_FAME_PATH = buildPath('hall-of-fame-index', {
  query: { type: API.HallOfFamerType.WEBSITE },
})

const Editor: PageConfig<Props> = ({ hallOfFame }) => (
  <Page>
    <SEO
      title="Our custom code editor helps new coders learn online"
      description="An intelligent code editor, designed to help making websites from scratch easier. Set up projects, host everything and get your sites online with one click."
      imageUrl={seoImageUrl}
      imageFm="png8"
    />

    <Main>
      <Hero />

      <Intro />

      <Features />

      {hallOfFame && (
        <HallOfFame
          {...hallOfFame}
          title="Sites our students make"
          subtitle="The proof is in the pudding. Our students go on to make their own beautiful sites and some of their stunning work has won digital design awards."
          type="WEBSITE"
          collapseTopPadding
          buttonText="View all student websites"
          buttonHref={HALL_OF_FAME_PATH}
          imagesLazy
        />
      )}

      <Callout />
    </Main>
  </Page>
)

Editor.route = ROUTE

export { getStaticProps } from './data'
export default Editor
